/**
 * Console Logging Gate
 *
 * Disables console logging unless APP_ENV is explicitly "development".
 *
 * NOTE:
 * - `APP_ENV` is mapped to `import.meta.env.VITE_APP_ENV` in `vite.config.ts`.
 * - This module is intended to be imported as early as possible (e.g. first import in `src/main.tsx`).
 */

type ConsoleMethod = 'log' | 'info' | 'debug' | 'warn' | 'error' | 'trace' | 'group' | 'groupCollapsed' | 'groupEnd' | 'table' | 'dir' | 'dirxml' | 'time' | 'timeEnd' | 'timeLog' | 'assert';

const APP_ENV = import.meta.env.VITE_APP_ENV as string | undefined;

/**
 * Logging is allowed ONLY when APP_ENV is exactly "development".
 */
export const isClientLoggingAllowed = APP_ENV === 'development';

if (!isClientLoggingAllowed) {
  const noop = () => undefined;

  const methods: ConsoleMethod[] = ['log', 'info', 'debug', 'warn', 'error', 'trace', 'group', 'groupCollapsed', 'groupEnd', 'table', 'dir', 'dirxml', 'time', 'timeEnd', 'timeLog', 'assert'];

  for (const method of methods) {
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (console as any)[method] = noop;
    } catch {
      // If the runtime makes a method non-writable, ignore and continue.
    }
  }
}
